 function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import React, {Suspense, useCallback} from 'react'
import {useHistory, useLocation} from 'react-router'
import useRouter from '../hooks/useRouter'
import ShareTopicModal from '~/components/ShareTopicModal'
import {Loader} from '../utils/relay/renderLoader'
import useQueryLoaderNow from '../hooks/useQueryLoaderNow'
import shareTopicModalQuery, {

} from '../__generated__/ShareTopicModalQuery.graphql'

const ShareTopicRouterRoot = () => {
  const {match} = useRouter()
  const {params} = match

  const {meetingId, stageId} = params

  const queryRef = useQueryLoaderNow(
    shareTopicModalQuery,
    {meetingId},
    'network-only'
  )

  const location = useLocation()
  const history = useHistory()

  const onClose = useCallback(() => {
    const state = location.state
    history.replace(_nullishCoalesce(_optionalChain([state, 'optionalAccess', _ => _.backgroundLocation]), () => ( `/new-summary/${meetingId}`)))
  }, [location])

  return (
    React.createElement(Suspense, { fallback: React.createElement(Loader, null ),}
      , queryRef && (
        React.createElement(ShareTopicModal, {
          stageId: stageId,
          meetingId: meetingId,
          isOpen: true,
          onClose: onClose,
          queryRef: queryRef,}
        )
      )
    )
  )
}

export default ShareTopicRouterRoot
